import styled from '@emotion/styled';
import React from 'react';
import { FlexContainer, FlexItem } from '../FlexLayout';
import { colors } from '../styles/colors';

const StyledInput = styled.input<{ $hasError?: boolean }>`
  width: 100%;
  max-width: 213px;
  margin-left: auto !important;
  border: 1px solid
    ${({ $hasError }) => ($hasError ? colors.red.primary : colors.gray.primary)} !important;
  box-shadow: ${({ $hasError }) =>
    ($hasError ? `0 0 0 1px ${colors.red.primary}` : `0 0 0 1px ${colors.gray.primary}`)};

  &:focus {
    outline: none;
    box-shadow: ${({ $hasError }) =>
      ($hasError ? `0 0 0 1px ${colors.red.primary}` : `0 0 0 1px ${colors.gray.primary}`)};
  }

  @media only screen and (max-width: 1010px) {
    width: 100% !important;
  }
`;

const ValidationText = styled.div`
  color: ${colors.red.primary};
  font-size: 12px;
  margin-top: 4px;
`;

interface InputFieldProps
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  label: string;
  error?: boolean;
  helperText?: string;
}

interface InputFieldIconProps extends InputFieldProps {
  ToggleDisabledComponent: React.ComponentType;
}

export const InputField = ({ label, ...props }: InputFieldProps) => {
  const { error, helperText, id } = props;
  const validationTextId = `${id}-validation-error`;

  return (
    <FlexContainer justify="space-between">
      <FlexItem>
        <label htmlFor="signature">{label}</label>
      </FlexItem>
      <FlexItem width={50}>
        <StyledInput
          {...props}
          $hasError={error}
          aria-invalid={error}
          aria-describedby={error && helperText ? validationTextId : undefined}
        />
        {error && helperText && (
          <ValidationText id={validationTextId} role="alert">
            {helperText}
          </ValidationText>
        )}
      </FlexItem>
    </FlexContainer>
  );
};

export const InputFieldIcon = ({ label, ToggleDisabledComponent, ...props }: InputFieldIconProps) => {
  const { error, helperText, id } = props;
  const validationTextId = `${id}-validation-error`;

  return (
    <FlexContainer justify="space-between">
      <FlexItem>
        <label htmlFor="signature">{label}</label>
      </FlexItem>
      <FlexItem width={61.5}>
        <FlexContainer justify="right-align">
          <ToggleDisabledComponent />
          <StyledInput
            {...props}
            $hasError={error}
            aria-invalid={error}
            aria-describedby={error && helperText ? validationTextId : undefined}
          />
        </FlexContainer>
        {error && helperText && (
          <ValidationText id={validationTextId} role="alert">
            {helperText}
          </ValidationText>
        )}
      </FlexItem>
    </FlexContainer>
  );
};